module.exports = "/_next/static/images/swift-0c210fc362738997df161ea9279baf84.png";